module.exports = "/_next/static/images/gurgaon_top-d7dadc1ac4c0f6bf4e7d586bd0f96ca7.jpg";